<template>
  <div>
    <px-view-header title="Meu painel" :breadcrumbs="breadcrumbs">
      <template v-slot:after>
        <px-ajuda-icon :link="ajuda"/>
      </template>
    </px-view-header>
    <div v-if="loading">
      <px-circular-loading/>
    </div>
    <v-row v-if="!loading && transportador">
      <v-col cols="12" sm="6">
        <px-meu-painel-avaliacao :transportador="transportador"/>
      </v-col>
      <v-col cols="12" sm="6">
        <px-meu-painel-score :transportador="transportador"/>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="6">
        <px-meu-painel-cotacoes-frete/>
      </v-col>
      <v-col cols="12" sm="12" md="12" lg="6">
        <px-meu-painel-contratacoes-frete/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { meuPainel } from '@/api/ajuda-mapper';
import MeuPainelContratacoesFrete from './MeuPainelContratacoesFrete.vue';
import MeuPainelCotacoesFrete from './MeuPainelCotacoesFrete.vue';
import MinhaPaginaService from './minha-pagina-service';
import MeuPainelScore from './MeuPainelScore.vue';
import MeuPainelAvaliacao from './MeuPainelAvaliacao.vue';

export default {
  data() {
    return {
      transportador: null,
      loading: false,
      ajuda: meuPainel,
      breadcrumbs: [
        { text: 'Indicadores' },
        { text: 'Meu painel' },
      ],
    };
  },
  methods: {
    getFornecedorScoreAvaliacao() {
      this.loading = true;
      MinhaPaginaService.get()
        .then(({ data }) => {
          this.transportador = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.getFornecedorScoreAvaliacao();
  },
  components: {
    pxMeuPainelContratacoesFrete: MeuPainelContratacoesFrete,
    pxMeuPainelCotacoesFrete: MeuPainelCotacoesFrete,
    pxMeuPainelScore: MeuPainelScore,
    pxMeuPainelAvaliacao: MeuPainelAvaliacao,
  },
};
</script>
